import React from "react";
import PropTypes from "prop-types";
import { CardTitle, FormGroup } from "reactstrap";
import { Field } from "formik";

import UserLicenseCheckboxes from "./UserLicenseCheckbox";

const UserLicenseSettings = ({ availableUserLicenses, onLicensesChange }) => (
  <Field name="userLicenses">
    {() => (
      <FormGroup name="licensesGroup" className="sb-field-group">
        <CardTitle>License Types</CardTitle>
        {availableUserLicenses.map(({ name, label }) =>
          <UserLicenseCheckboxes
            key={name}
            name={`userLicenses.${name}`}
            label={label}
            onLicensesChange={onLicensesChange}
          />
        )}
        Determine the type of License for this network.
      </FormGroup>
    )}
  </Field>
);

UserLicenseSettings.propTypes = {
  availableUserLicenses: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  onLicensesChange: PropTypes.func.isRequired
};

export default UserLicenseSettings;
